import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import ErrorBoundary from "./components/ErrorBoundary";
import ResetPassword from "./pages/ResetPassword";
import Incidents from "./pages/Incidents";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import Websites from "./pages/Websites";
import WebsiteDetail from "./pages/WebsiteDetail";
import Settings from "./pages/Settings";
import Reports from "./pages/Reports";
import Admin from "./pages/Admin";
import StatusPageManager from "./pages/StatusPageManager";
import PublicStatus from "./pages/PublicStatus";

function ProtectedRoute() {
  const { user, authError, refresh } = useAuth();
  if (authError) return <main className="min-h-screen flex items-center justify-center p-6"><div role="alert" className="max-w-md space-y-4"><h1 className="text-xl font-semibold">Connection interrupted</h1><p>{authError}</p><button className="rounded-lg bg-blue-600 px-4 py-2 text-white" onClick={refresh}>Try again</button></div></main>;
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <Loader2 className="h-6 w-6 animate-spin text-blue-600" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  if (user && user !== false) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <ErrorBoundary><div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/status/:slug" element={<PublicStatus />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/websites" element={<Websites />} />
                <Route path="/websites/:id" element={<WebsiteDetail />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/incidents" element={<Incidents />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/status-page" element={<StatusPageManager />} />
                <Route path="/admin" element={<Admin />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div></ErrorBoundary>
  );
}

export default App;
